import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { RichText } from "prismic-dom";
import { Box, Flex } from "rebass";
import {
  Head,
  H1,
  H2,
  H3,
  H4,
  Text,
  Card,
  CardLayout,
  Article,
  Main,
  GradientHeader,
  GradientCard,
  PrimaryButton,
  Button,
  PageHeader,
  PageSidebar,
  PageContent,
  PageSection,
  CalloutCard,
  CalloutContainer,
} from "components";
import Link from "gatsby-link";
import { LazyImage } from "components";

let linkResolver = function (doc) {
  return "/" + doc.type;
};

const Layout = styled(Flex)`
  align-items: stretch;

  @media (max-width: 45em) {
    flex-wrap: wrap;
    > * {
      width: 100%;
      margin-bottom: ${(props) => props.theme.space[1]}px;

      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
    > *:last-child {
      margin-bottom: ${(props) => props.theme.space[0]}px;
    }
  }
  @media (min-width: 45em) {
    flex-wrap: wrap;
    > * {
      width: ${(props) =>
        "calc(" + (1 / 2) * 100 + "% - " + props.theme.space[4] / 2 + "px)"};
      margin-bottom: ${(props) => props.theme.space[5]}px;

      &:not(:lang(ar)) {
        margin-left: ${(props) => props.theme.space[4]}px;
      }
      &:lang(ar) {
        margin-right: ${(props) => props.theme.space[4]}px;
      }
    }
    > *:nth-child(2n + 1) {
      &:not(:lang(ar)) {
        margin-left: 0;
      }
      &:lang(ar) {
        margin-right: 0;
      }
    }
    /* > *:nth-last-child(-n + 2) {
      margin-bottom: ${(props) => props.theme.space[0]}px;
    } */
    > * {
      &:nth-last-child(2):nth-child(odd),
      &:last-child {
        margin-bottom: ${(props) => props.theme.space[0]}px;
      }
    }
  }
`;

class Support extends React.Component {
  static contextTypes = {
    setAltLanguages: PropTypes.func,
  };
  componentDidMount() {
    this.context.setAltLanguages(undefined);
  }
  render() {
    let json = "";
    if (this.props.data.support.raw) {
      json = JSON.parse(this.props.data.support.raw);
    }
    return (
      <Box
        style={
          this.props.transition ? this.props.transition.style : { opacity: 0 }
        }
      >
        <Head source={json.data} />
        <Main>
          <PageHeader title={json.data.title[0].text} color={json.uid}>
            {json.data.subtitle[0] && (
              <H2 children={json.data.subtitle[0].text} fontSize={[4, 5]} />
            )}
            {json.data.description[0] && (
              <Text children={json.data.description[0].text} />
            )}
            <Box mt={5}>
              <Button
                children={
                  json.lang === "en-us"
                    ? "Donate now"
                    : json.lang === "es-mx"
                    ? "Donar"
                    : "تبرّع الى مركز معلومات البنك"
                }
                is="a"
                href={
                  "https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=KJVPAP6TRBTEJ"
                }
                target="_blank"
              />
            </Box>
          </PageHeader>
          <PageSection>
            {json.data.body1[0] && (
              <PageSidebar>
                <CalloutContainer>
                  {json.data.body1.map((callout, index) => (
                    <CalloutCard
                      key={"callout" + index}
                      callout={callout.primary}
                      lang={json.lang}
                    />
                  ))}
                </CalloutContainer>
              </PageSidebar>
            )}
            <PageContent>
              {json.data.body && (
                <Article
                  dangerouslySetInnerHTML={{
                    __html: RichText.asHtml(json.data.body, linkResolver),
                  }}
                />
              )}
              <Box mt={6} mx={[-24, 0]}>
                {json.data.action[0] && (
                  <Layout>
                    {json.data.action.map((actionItem, index) => (
                      <GradientCard image={actionItem.action_image.url}>
                        <Box>
                          <H4 children="Take Action" mb={5} />
                          {actionItem.action_title[0] && (
                            <H2
                              children={actionItem.action_title[0].text}
                              mb={5}
                              fontSize={[4, 5]}
                            />
                          )}
                          <PrimaryButton
                            children={actionItem.button_text}
                            is="a"
                            href={actionItem.button_link}
                          />
                        </Box>
                      </GradientCard>
                    ))}
                  </Layout>
                )}
              </Box>
            </PageContent>
          </PageSection>
        </Main>
      </Box>
    );
  }
}

export default Support;

export const query = graphql`
  query SupportQuery($id: String!) {
    support: prismicDocument(prismicId: { eq: $id }) {
      uid
      id
      raw
      lang
    }
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/support.js